import { DEFAULT_RSS_FEED_POSTS_NUM, RSS_FEED_POSTS_OPTIONS } from '@/constants';

const RSS_FEED_POSTS_OPTIONS_SET = new Set<number>(RSS_FEED_POSTS_OPTIONS);

type NormalizeRssFeedPostsNumParams = {
  rssFeedPostsNum: number | null | undefined;
};

export const isValidRssFeedPostsNum = ({ rssFeedPostsNum }: NormalizeRssFeedPostsNumParams): boolean => {
  if (rssFeedPostsNum == null) {
    return false;
  }

  return RSS_FEED_POSTS_OPTIONS_SET.has(rssFeedPostsNum);
};

export const normalizeRssFeedPostsNum = ({ rssFeedPostsNum }: NormalizeRssFeedPostsNumParams): number => {
  if (isValidRssFeedPostsNum({ rssFeedPostsNum })) {
    return rssFeedPostsNum as number;
  }

  return DEFAULT_RSS_FEED_POSTS_NUM;
};
